export default {
  data() {
    return {
      props: {
        tag: '',
        width: '748px',
        zIndex: 'auto',
        maxWidth: '1920px',
        hideDesktopOrder: 0,
        hideMobileOrder: 0
      },
      sidebar: '2',
      internal_config: {
        version: 'v1.4',
        width: '748px',
        height: 'auto',
        maxWidth: '1920px',
        zIndex: 'auto',
        showDesktop: true,
        showMobile: true,
        hideDesktopOrder: 0,
        hideMobileOrder: 0,
        sellableHash: '',
        type: '',
        language: '',
        theme: {},
        texts: {},
        steps: 1
      },
      name: 'checkout',
      assets: {
        mount: null,
        js: null,
        i18n: null
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/components/editor/apps/Checkout/Model.js